import { apiClient } from "../lib/api";

export const emailDeliveryApi = {
  featureFlags: () => apiClient.get("/email/feature-flags"),
  listTemplates: () => apiClient.get("/email/templates"),
  listDeliveries: (status, templateKey) => apiClient.get("/email/deliveries", { params: { status: status || undefined, template_key: templateKey || undefined } }),
  getAttempts: (deliveryId) => apiClient.get(`/email/deliveries/${deliveryId}/attempts`),
  resend: (deliveryId) => apiClient.post(`/email/deliveries/${deliveryId}/resend`),
  listSuppressions: () => apiClient.get("/email/suppressions"),
  addSuppression: (email, reason) => apiClient.post("/email/suppressions", { email, reason }),
};
